import { z } from "zod";
import { isReservedI18nextOptionKey } from "../../i18n/reservedKeys.js";

/**
 * Zod validator factory for i18next interpolation params (`warningParams`,
 * `problemParams`, `fixParams`, ...): a record of string | number template values.
 * Keys colliding with reserved i18next option names (`count`, `defaultValue`, ...)
 * are always rejected — they would change lookup behavior instead of interpolating.
 * Pass `validKeys` to additionally restrict params to a declared set; reserved names
 * are never valid, even if listed.
 */
export function translationParamsZodValidator(validKeys?: readonly string[]) {
    const allowed = validKeys?.filter((key) => !isReservedI18nextOptionKey(key));
    return z
        .record(z.string(), z.union([z.string(), z.number()], { error: "must be a string or number" }))
        .superRefine((params, ctx) => {
            Object.keys(params).forEach((key) => {
                const invalid = isReservedI18nextOptionKey(key) || (allowed !== undefined && !allowed.includes(key));
                if (!invalid) return;
                ctx.addIssue({
                    code: "custom",
                    path: [key],
                    message:
                        allowed !== undefined
                            ? `"${key}" is not a valid key. Valid keys include: ${
                                  allowed.length ? allowed.map((k) => `"${k}"`).join(", ") : "(none)"
                              }`
                            : `"${key}" is not a valid key (reserved i18next option name)`,
                });
            });
        });
}
